import React, { useContext, useState, useRef, useEffect } from 'react';
import Modal from '../../../components/modals';
import Context from '../../../../context/context';
import InputHeader from '../../global/inputwithHeader';
import DatePicker from 'react-datepicker';
import CustomDateInput from '../../global/customDateInput';
import moment from 'moment';
import Select from 'react-select';
import { ReactComponent as ArrowIcon } from '../../../../assets/svg/deliverables/single_up_arrow.svg';
import { ReactComponent as EqualIcon } from '../../../../assets/svg/deliverables/equalto.svg';
import { ReactComponent as DownIcon } from '../../../../assets/svg/deliverables/single_down_arrow.svg';
import { ReactComponent as PlusIcon } from '../../../../assets/svg/plus-gray.svg';
import { useParams } from 'react-router-dom';
import { message } from 'antd';
import { ReactComponent as DeleteIcon } from '../../../../assets/svg/trash3.svg';
import { toast } from 'react-toastify';
import _ from 'lodash';

const CreateDeliverSlider = ({ project, workspace, type }) => {
	let {
		deliverableInfo: {
			updateModalState,
			createModal,
			workspaceTenants,
			getAllWorkspaceTenants,
			createNewDeliverable,
			createNewDeliverableState,
			updateDeliverable,
			UpdateDeliverableState,
			UpdateRecord,
			updateRecord,
			cancelUpdate,
			associatedTenants,
		},
	} = useContext(Context);

	const urlParams = useParams();
	const deliverDetails = useRef(null);
	const assignedTo = useRef(null);
	const notes = useRef(null);

	const [pageInfo, setPageinfo] = useState({
		discard: false,
		activeTag: 'details',
		workspacetennatsOptions: [],
		cost: null,
		defaultAssinedto: {},
		currentNote: '',
		storedNote: [],
		UpdatedorCreatedBy: '',
	});

	let formfillData = {
		workspaceId: workspace?.label,
		projectId: project?.value,
		deliverableInput: {
			dueDate: '',
			status: '',
			title: '',
			quantity: '',
			priority: '',
			cost: 0,
			assignedTo: '',
			notes: {
				message: '',
			},
		},
	};

	const [formaData, setFormData] = useState(formfillData);

	useEffect(() => {
		if (type === 'edit' && UpdateRecord) {
			setFormData({
				workspaceId: workspace?.label,
				projectId: UpdateRecord.projectId,
				updateDeliverableId: UpdateRecord.id,
				deliverableInput: {
					dueDate: UpdateRecord.dueDate,
					status: UpdateRecord.status,
					title: UpdateRecord.title,
					quantity: UpdateRecord.quantity,
					priority: UpdateRecord.priority,
					cost: UpdateRecord.cost || 0,
					assignedTo:
						_.has(UpdateRecord.assignedTo, 'id') &&
						_.has(UpdateRecord.assignedTo, 'name')
							? {
									id: UpdateRecord.assignedTo?.id || '',
									name: UpdateRecord.assignedTo?.name || '',
							  }
							: {},
					notes: UpdateRecord.notes,
				},
			});

			setPageinfo((prev) => {
				return {
					...prev,
					storedNote: UpdateRecord.notes,
				};
			});
		}
	}, [UpdateRecord]);

	useEffect(() => {
		let wjson = {
			workspaceIds: workspace?.label,
		};

		getAllWorkspaceTenants(wjson, urlParams.vendorID);
	}, [workspace, createModal]);

	// useEffect(() => {
	// 	if (createModal) {
	// 		let wjson = {
	// 			workspaceIds: workspace?.label,
	// 		};
	// 		getAllWorkspaceTenants(wjson, urlParams.vendorID);
	// 	}
	// }, [createModal]);
	useEffect(() => {
		let workspacetennatsOptions = workspaceTenants?.tenantUsersList?.map((ele) => {
			return {
				label: ele.firstName + ' ' + ele.lastName,
				value: ele.id,
			};
		});

		let defaultAssinedto, UpdatedorCreatedBy;
		if (UpdateRecord) {
			// defaultAssinedto = workspacetennatsOptions?.filter(
			// 	(e) => e.value === UpdateRecord?.assignedTo,
			// );
			UpdatedorCreatedBy = associatedTenants?.vendorUsers?.filter(
				(e) => e.id === UpdateRecord?.updatedBy,
			);
			UpdatedorCreatedBy =
				UpdatedorCreatedBy[0]?.firstName + ' ' + UpdatedorCreatedBy[0]?.lastName;
		}

		setPageinfo((prev) => ({
			...prev,
			workspacetennatsOptions,
			defaultAssinedto,
			UpdatedorCreatedBy,
		}));
	}, [workspaceTenants]);

	useEffect(() => {
		if (createNewDeliverableState?.status === 'success') {
			// updateModalState('createModal', false);
			setFormData({
				workspaceId: workspace.label,
				projectId: project.value,
				deliverableInput: {
					dueDate: '',
					status: '',
					title: '',
					quantity: '',
					priority: '',
					cost: 0,
					assignedTo: '',
				},
			});
			setPageinfo({
				discard: false,
				activeTag: 'details',
				workspacetennatsOptions: [],
				cost: null,
				defaultAssinedto: {},
				currentNote: '',
				storedNote: [],
				UpdatedorCreatedBy: '',
			});
		}
		if (createNewDeliverableState?.status === 'failed') {
			updateModalState('createModal', false);
			message.error(createNewDeliverableState?.payload);
			setFormData({
				workspaceId: workspace.label,
				projectId: project.value,
				deliverableInput: {
					dueDate: '',
					status: '',
					title: '',
					quantity: '',
					priority: '',
					cost: 0,
					assignedTo: '',
				},
			});
			setPageinfo({
				discard: false,
				activeTag: 'details',
				workspacetennatsOptions: [],
				cost: null,
				defaultAssinedto: {},
				currentNote: '',
				storedNote: [],
				UpdatedorCreatedBy: '',
			});
		}
	}, [createNewDeliverableState]);

	useEffect(() => {
		// if (UpdateDeliverableState?.status === 'success') {
		// 	// updateModalState('createModal', false);
		// 	updateRecord(null);
		// 	setFormData(formfillData);
		// 	setPageinfo({
		// 		discard: false,
		// 		activeTag: 'details',
		// 		workspacetennatsOptions: [],
		// 		cost: null,
		// 		defaultAssinedto: {},
		// 		currentNote: '',
		// 		storedNote: [],
		// 		UpdatedorCreatedBy: '',
		// 	});
		// }
		if (UpdateDeliverableState?.status === 'failed') {
			updateModalState('createModal', false);
			updateRecord(null);
			message.error(UpdateDeliverableState?.payload);
			setFormData(formfillData);
			setPageinfo({
				discard: false,
				activeTag: 'details',
				workspacetennatsOptions: [],
				cost: null,
				defaultAssinedto: {},
				currentNote: '',
				storedNote: [],
				UpdatedorCreatedBy: '',
			});
		}
	}, [UpdateDeliverableState]);

	const priorityOptions = [
		{
			value: 'critical',
			label: (
				<span style={{ display: 'flex' }}>
					<span
						style={{
							marginRight: '15px',
							width: '15.286px',
							height: '13.999px',
							display: 'flex',
							flexDirection: 'column',
						}}
					>
						<ArrowIcon />
						<ArrowIcon />
					</span>
					<span>Critical</span>
				</span>
			),
		},
		{
			value: 'high',
			label: (
				<span>
					<span style={{ marginRight: '15px', width: '15.286px', height: '13.999px' }}>
						<ArrowIcon />
					</span>
					<span>High</span>
				</span>
			),
		},
		{
			value: 'medium',
			label: (
				<span>
					<span style={{ marginRight: '15px', width: '15.286px', height: '13.999px' }}>
						<EqualIcon />
					</span>
					<span>Medium</span>
				</span>
			),
		},
		{
			value: 'low',
			label: (
				<span>
					<span style={{ marginRight: '15px', width: '15.286px', height: '13.999px' }}>
						<DownIcon />
					</span>
					<span>Low</span>
				</span>
			),
		},
	];
	const statusPriorityOptions = [
		{
			label: (
				<span style={{ display: 'flex', alignItems: 'center' }}>
					<span className="delivarableStatusCheck">
						<b style={{ backgroundColor: '#9F4DB7', marginRight: '15px' }}></b>
					</span>

					<span
						style={{
							// color: formaData.status==='todo'?'#E4E5E6':'#333',
							fontFamily: 'Inter',
							fontSize: '14px',
							fontStyle: 'normal',
							fontWeight: '400',
							lineHeight: '16px',
							letterSpacing: '-0.3px',
						}}
					>
						To Do
					</span>
				</span>
			),
			value: 'todo',
		},

		{
			label: (
				<span style={{ display: 'flex', alignItems: 'center' }}>
					<span className="delivarableStatusCheck">
						<b style={{ backgroundColor: '#5383EC', marginRight: '15px' }}></b>
					</span>

					<span
						style={{
							// color: formaData.status==='todo'?'#E4E5E6':'#333',
							fontFamily: 'Inter',
							fontSize: '14px',
							fontStyle: 'normal',
							fontWeight: '400',
							lineHeight: '16px',
							letterSpacing: '-0.3px',
						}}
					>
						In Progress
					</span>
				</span>
			),
			value: 'inProgress',
		},
		{
			label: (
				<span style={{ display: 'flex', alignItems: 'center' }}>
					<span className="delivarableStatusCheck">
						<b style={{ backgroundColor: '#8EE2C7', marginRight: '15px' }}></b>
					</span>

					<span
						style={{
							// color: formaData.status==='todo'?'#E4E5E6':'#333',
							fontFamily: 'Inter',
							fontSize: '14px',
							fontStyle: 'normal',
							fontWeight: '400',
							lineHeight: '16px',
							letterSpacing: '-0.3px',
						}}
					>
						In Review
					</span>
				</span>
			),
			value: 'inReview',
		},
		{
			label: (
				<span style={{ display: 'flex', alignItems: 'center' }}>
					<span className="delivarableStatusCheck">
						<b style={{ backgroundColor: '#479A5F', marginRight: '15px' }}></b>
					</span>

					<span
						style={{
							// color: formaData.status==='todo'?'#E4E5E6':'#333',
							fontFamily: 'Inter',
							fontSize: '14px',
							fontStyle: 'normal',
							fontWeight: '400',
							lineHeight: '16px',
							letterSpacing: '-0.3px',
						}}
					>
						Done
					</span>
				</span>
			),
			value: 'done',
			color: '#FF8B00',
		},
		{
			label: (
				<span style={{ display: 'flex', alignItems: 'center' }}>
					<span className="delivarableStatusCheck">
						<b style={{ backgroundColor: 'rgb(255, 87, 51)', marginRight: '15px' }}></b>
					</span>

					<span
						style={{
							// color: formaData.status==='todo'?'#E4E5E6':'#333',
							fontFamily: 'Inter',
							fontSize: '14px',
							fontStyle: 'normal',
							fontWeight: '400',
							lineHeight: '16px',
							letterSpacing: '-0.3px',
						}}
					>
						On Hold
					</span>
				</span>
			),
			value: 'onHold',
			color: '#FF8B00',
		},
	];
	const costOptions = [
		{ label: 'Include in package', value: 0 },
		{ label: 'Additional cost', value: 1 },
	];
	const handleScroll = (ref) => {
		ref.scrollIntoView({ behavior: 'smooth', block: 'start' });
	};

	useEffect(() => {
		let arr = pageInfo?.storedNote;

		if (arr) {
			arr = arr?.map((ele) => {
				return { message: ele.message };
			});

			setFormData((prev) => {
				return {
					...prev,
					deliverableInput: { ...prev.deliverableInput, notes: [...arr] },
				};
			});
		}
	}, [pageInfo.storedNote]);

	return (
		<>
			<Modal
				handleClose={() =>
					setPageinfo((prev) => {
						return { ...prev, discard: true };
					})
				}
				show={createModal}
				modalType={'right-add'}
				// custClass={_.has(this.props, 'custClass') ? this.props.custClass : ''}
			>
				<div className="createdeliverSlider">
					<div className="Sliderheader">
						<div className="sliderheaderTitle">
							<span className="slidertitle">New Deliverable</span>
						</div>
						<div className="sliderTab">
							<span
								style={{
									cursor: 'pointer',
									color: pageInfo.activeTag === 'details' ? '#E4E5E6' : '#707070',
								}}
								onClick={() => {
									setPageinfo((prev) => {
										return { ...prev, activeTag: 'details' };
									});
									handleScroll(deliverDetails.current);
								}}
							>
								Details
							</span>
							<span
								style={{
									cursor: 'pointer',
									color:
										pageInfo.activeTag === 'assigned' ? '#E4E5E6' : '#707070',
								}}
								onClick={() => {
									setPageinfo((prev) => {
										return { ...prev, activeTag: 'assigned' };
									});
									handleScroll(assignedTo.current);
								}}
							>
								Assigned To
							</span>

							<span
								style={{
									cursor: 'pointer',
									color: pageInfo.activeTag === 'notes' ? '#E4E5E6' : '#707070',
								}}
								onClick={() => {
									setPageinfo((prev) => {
										return { ...prev, activeTag: 'notes' };
									});
									handleScroll(notes.current);
								}}
							>
								Notes
							</span>
						</div>
					</div>
					<div className="sliderBody">
						<div className="deliverableDetails" ref={deliverDetails}>
							<label>DELIVERABLE DETAILS</label>

							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									alignItems: 'flex-start',
									gap: '8px',
									alignSelf: 'stretch',
									// marginTop: '24px',
								}}
							>
								<span style={{ marginTop: '24px', width: '100%' }}>
									<InputHeader
										type="text"
										name="project"
										value={project?.label}
										readOnly={true}
										onChange={(e) => {}}
										isInputError={false}
										label="Project"
										width="100%"
										autocomplete="false"
									/>
								</span>
								<span style={{ marginTop: '', width: '100%' }}>
									<InputHeader
										value={formaData.deliverableInput.title}
										type="text"
										name="title"
										readOnly={false}
										onChange={(e) => {
											setFormData((prev) => {
												return {
													...prev,
													deliverableInput: {
														...prev.deliverableInput,
														title: e.target.value,
													},
												};
											});
										}}
										isInputError={false}
										label="Name *"
										width="100%"
										autocomplete="off"
										defaultValue={formaData.deliverableInput.title}
									/>
								</span>

								<span style={{ marginTop: '24px', width: '100%' }}>
									<InputHeader
										value={formaData.deliverableInput.quantity}
										type="text"
										name="name"
										readOnly={false}
										onChange={(e) =>
											setFormData((prev) => {
												return {
													...prev,
													deliverableInput: {
														...prev.deliverableInput,
														quantity: +e.target.value.replace(
															/\D/g,
															'',
														),
													},
												};
											})
										}
										isInputError={false}
										label="Quantity"
										width="100%"
										autocomplete="off"
									/>
								</span>

								<div
									style={{
										width: '100%',
										// padding: '30px',
										// position: 'fixed',
										marginTop: '24px',
										zIndex: '9999',
									}}
								>
									<DatePicker
										selected={
											formaData?.deliverableInput?.dueDate
												? moment(
														formaData.deliverableInput.dueDate.toString(),
														'YYYYMMDD',
												  ).toDate()
												: ''
										}
										onChange={(e) => {
											setFormData((prev) => {
												return {
													...prev,
													deliverableInput: {
														...prev.deliverableInput,
														dueDate: parseInt(
															moment(e).format('yyyyMMDD'),
														),
													},
												};
											});
										}}
										dateFormat="dd/MM/yyyy"
										placeholderText="dd / mm / yyyy"
										openToDate={new Date()}
										customInput={<CustomDateInput customLabel="Due Date" />}
										wrapperClassName={`w-100p`}
									/>
								</div>

								<div
									style={{
										width: '100%',
										// padding: '30px',
										// position: 'fixed',
										marginTop: '24px',
										zIndex: '7999',
									}}
								>
									<label
										style={{
											color: '#B0B0B0',
											fontFamily: 'Inter',
											fontSize: '13px',
											fontStyle: 'normal',
											fontWeight: '400',
											lineHeight: '16px',
											letterSpacing: '-0.3px',
										}}
									>
										Priority
									</label>
									<br />

									<Select
										className="cost-select-container"
										classNamePrefix="cost-select"
										options={priorityOptions}
										onChange={(e) => {
											setFormData((prev) => {
												return {
													...prev,
													deliverableInput: {
														...prev.deliverableInput,
														priority: e.value,
													},
												};
											});
										}}
										defaultValue={
											UpdateRecord
												? priorityOptions.filter(
														(e) => e.value === UpdateRecord.priority,
												  )
												: null
										}
									/>
								</div>
								<div
									style={{
										width: '100%',
										// padding: '30px',
										// position: 'fixed',
										marginTop: '24px',
										zIndex: '6999',
									}}
								>
									<label
										style={{
											color: '#B0B0B0',
											fontFamily: 'Inter',
											fontSize: '13px',
											fontStyle: 'normal',
											fontWeight: '400',
											lineHeight: '16px',
											letterSpacing: '-0.3px',
										}}
									>
										Status
									</label>
									<br />

									<Select
										className="cost-select-container"
										classNamePrefix="cost-select"
										options={statusPriorityOptions}
										onChange={(e) => {
											setFormData((prev) => {
												return {
													...prev,
													deliverableInput: {
														...prev.deliverableInput,
														status: e.value,
													},
												};
											});
										}}
										defaultValue={
											UpdateRecord
												? statusPriorityOptions.filter(
														(e) => e.value === UpdateRecord.status,
												  )
												: null
										}
									/>
								</div>

								{type === 'edit' ? (
									<span style={{ marginTop: '45px', width: '100%' }}>
										<InputHeader
											value={formaData.deliverableInput.cost}
											type="text"
											name="name"
											readOnly={false}
											onChange={(e) =>
												setFormData((prev) => {
													return {
														...prev,
														deliverableInput: {
															...prev.deliverableInput,
															cost: +e.target.value.replace(
																/\D/g,
																'',
															),
														},
													};
												})
											}
											isInputError={false}
											label="Cost"
											width="100%"
											autocomplete="off"
										/>
									</span>
								) : (
									<>
										<div
											style={{
												width: '100%',
												marginTop: '24px',
												zIndex: '5999',
											}}
										>
											<label
												style={{
													color: '#B0B0B0',
													fontFamily: 'Inter',
													fontSize: '13px',
													fontStyle: 'normal',
													fontWeight: '400',
													lineHeight: '16px',
													letterSpacing: '-0.3px',
												}}
											>
												Cost
											</label>
											<br />

											<Select
												className="cost-select-container"
												classNamePrefix="cost-select"
												options={costOptions}
												onChange={(e) => {
													setPageinfo((prev) => {
														return {
															...prev,
															cost: +e.value,
														};
													});
													if (+e.value === 0) {
														setFormData((prev) => {
															return {
																...prev,
																cost: 0,
															};
														});
													}
												}}
											/>
										</div>

										{pageInfo?.cost ? (
											<span style={{ marginTop: '45px', width: '100%' }}>
												<InputHeader
													value={formaData.deliverableInput.cost}
													type="text"
													name="name"
													readOnly={false}
													onChange={(e) =>
														setFormData((prev) => {
															return {
																...prev,
																deliverableInput: {
																	...prev.deliverableInput,
																	cost: +e.target.value.replace(
																		/\D/g,
																		'',
																	),
																},
															};
														})
													}
													isInputError={false}
													label="Additional Cost"
													width="100%"
													autocomplete="off"
												/>
											</span>
										) : (
											''
										)}
									</>
								)}
							</div>
						</div>

						<div className="assignedto" ref={assignedTo}>
							<label>ASSIGNED TO</label>
							<div
								style={{
									width: '100%',
									// padding: '30px',
									// position: 'fixed',
									marginTop: '24px',
									zIndex: '5999',
								}}
							>
								<label
									style={{
										color: '#B0B0B0',
										fontFamily: 'Inter',
										fontSize: '13px',
										fontStyle: 'normal',
										fontWeight: '400',
										lineHeight: '16px',
										letterSpacing: '-0.3px',
									}}
								>
									Name
								</label>
								<br />

								<Select
									className="cost-select-container"
									classNamePrefix="cost-select"
									options={pageInfo.workspacetennatsOptions}
									onChange={(e) => {
										setFormData((prev) => {
											return {
												...prev,
												deliverableInput: {
													...prev.deliverableInput,
													assignedTo: {
														id: e.value,
														name: e.label,
													},
												},
											};
										});
										setPageinfo((prev) => {
											return {
												...prev,
												defaultAssinedto: [e],
											};
										});
									}}
									value={{
										label: formaData.deliverableInput.assignedTo?.name || '',
										value: formaData.deliverableInput.assignedTo?.id || '',
									}}
								/>
							</div>
						</div>
						<div className="sliderNotes" ref={notes}>
							<label>Notes</label>

							{pageInfo.storedNote?.map((e, key) => {
								return (
									<div
										style={{
											display: 'flex',
											flexDirection: 'column',
											width: '100%',
										}}
									>
										<div style={{ width: '100%' }}>
											<div
												onClick={(e) => {
													let arr = pageInfo.storedNote;
													arr.splice(key, 1);
													setPageinfo((prev) => {
														return {
															...prev,
															storedNote: arr,
														};
													});
													arr = arr.map((ele) => {
														return { message: ele.message };
													});
													setFormData((prev) => {
														return {
															...prev,
															deliverableInput: {
																...prev.deliverableInput,
																notes: [...arr],
															},
														};
													});
												}}
												style={{
													position: 'relative',
													left: '95%',
													cursor: 'pointer',
												}}
											>
												<DeleteIcon />
											</div>

											<InputHeader
												textarea={true}
												type="text"
												isInputError={false}
												width="100%"
												label={`${
													pageInfo.UpdatedorCreatedBy ? 'by ' : ''
												}${
													pageInfo.UpdatedorCreatedBy
														? `${pageInfo.UpdatedorCreatedBy} ,`
														: ' '
												}  ${
													e.updatedAt
														? moment
																.unix(e.updatedAt)
																.format('D MMM YYYY h:mm a')
														: e?.createdAt
														? moment
																.unix(e.createdAt)
																.format('D MMM YYYY h:mm a')
														: ''
												}`}
												onChange={(e) => {
													let message = e.target.value;
													let arr = pageInfo.storedNote;
													arr.splice(key, 1, { message });
													setPageinfo((prev) => {
														return {
															...prev,
															storedNote: [...arr],
														};
													});
												}}
												value={e.message}
											/>
										</div>
									</div>
								);
							})}

							<div className="notes-item-container" style={{ width: '100%' }}>
								<InputHeader
									textarea={true}
									type="text"
									isInputError={false}
									label="New note"
									width="100%"
									onChange={(e) => {
										setPageinfo((prev) => {
											return { ...prev, currentNote: e.target.value };
										});
									}}
									value={pageInfo.currentNote}
									onBlur={(e) => {
										if (e.target.value !== '') {
											setPageinfo((prev) => {
												return {
													...prev,

													storedNote: [
														...prev.storedNote,
														{
															message: e.target.value,
															updatedBy:
																UpdateRecord?.updatedBy || '',
														},
													],
													currentNote: '',
												};
											});
										}
									}}
								/>
							</div>
						</div>
						<div className="sliderButtons">
							<div
								className="sliderCanceBtn"
								onClick={() =>
									setPageinfo((prev) => {
										return { ...prev, discard: true };
									})
								}
							>
								Cancel
							</div>
							<div
								className="sliderCreateDeliverable"
								onClick={() => {
									if (type === 'edit') {
										if (!formaData?.deliverableInput?.title?.length) {
											return toast.error('Please Enter valid Name!', {
												position: 'top-right',
												autoClose: 1000,
												hideProgressBar: false,
												closeOnClick: true,
												pauseOnHover: true,
												draggable: true,
												progress: undefined,
												theme: 'light',
											});
										}

										for (const key in formaData.deliverableInput) {
											if (formaData.deliverableInput[key] === '') {
												delete formaData.deliverableInput[key];
											}
										}

										updateDeliverable(formaData, urlParams.vendorID);
									} else {
										if (!formaData?.deliverableInput?.title?.length) {
											return toast.error('Please Enter valid Name!', {
												position: 'top-right',
												autoClose: 1000,
												hideProgressBar: false,
												closeOnClick: true,
												pauseOnHover: true,
												draggable: true,
												progress: undefined,
												theme: 'light',
											});
										}

										for (const key in formaData.deliverableInput) {
											if (formaData.deliverableInput[key] === '') {
												delete formaData.deliverableInput[key];
											}
										}

										createNewDeliverable(formaData, urlParams.vendorID);
									}
								}}
							>
								{type === 'edit' ? (
									<span>Update</span>
								) : (
									<span>
										<PlusIcon style={{ marginRight: '4px' }} /> Create
										Deliverable
									</span>
								)}
							</div>
						</div>
					</div>
				</div>
			</Modal>
			<Modal
				handleClose={() =>
					setPageinfo((prev) => {
						return { ...prev, discard: false };
					})
				}
				show={pageInfo.discard}
				modalType={'center'}
			>
				<div className="center-confirm-delete-new">
					<div className="delete-modal-header">DISCARD CHANGES</div>
					<div className="middle-delete-container">
						<div className="middle-text">Are you sure?</div>
						<div className="middle-desc">
							If you discard this information, you cannot undo this
						</div>
					</div>
					<div className="bottom-delete-btns">
						<span
							className="cancel-btn"
							onClick={() =>
								setPageinfo((prev) => {
									return { ...prev, discard: false };
								})
							}
						>
							No, Cancel
						</span>
						<span
							className="delete-btn"
							onClick={(e) => {
								setPageinfo((prev) => {
									return { ...prev, discard: false };
								});
								cancelUpdate();
								updateModalState('createModal', false);

								setFormData(formfillData);
								setPageinfo({
									discard: false,
									activeTag: 'details',
									workspacetennatsOptions: [],
									cost: null,
									defaultAssinedto: {},
									currentNote: '',
									storedNote: [],
									UpdatedorCreatedBy: '',
								});
							}}
						>
							Yes, Discard
						</span>
					</div>
				</div>
			</Modal>
		</>
	);
};

export default CreateDeliverSlider;
